const ASSISTANT_ARTIFACT_PATH = '/assistant/shared_artifacts/';

export interface AssistantArtifactMatch {
  token: string;
  version?: string;
}

function escapeForRegex(text: string) {
  return text.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
}

function buildAssistantArtifactRegex(): RegExp {
  const host = escapeForRegex(window.location.host);
  return new RegExp(
    `^https?:\\/\\/(?:[^\\s]*${host})${escapeForRegex(
      ASSISTANT_ARTIFACT_PATH
    )}([A-Za-z0-9]+)(?:\\/(\\d+))?(?:\\?.*)?$`
  );
}

/**
 * Parses a string for assistant artifact URLs and extracts the token and version.
 * Example URL: https://example.aha.io/assistant/shared_artifacts/abc123/1
 */
export function parseAssistantArtifactUrls(
  rawText: string
): AssistantArtifactMatch[] {
  const regex = buildAssistantArtifactRegex();
  const seen = new Set<string>();
  const matches: AssistantArtifactMatch[] = [];

  rawText
    .split(/\s+/)
    .map(part => part.trim())
    .filter(Boolean)
    .forEach(candidate => {
      const match = candidate.match(regex);
      if (!match) return;
      const [, token, version] = match;
      const key = `${token}:${version ?? ''}`;
      if (seen.has(key)) return;
      seen.add(key);
      matches.push({ token, version: version ?? undefined });
    });

  return matches;
}
